<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

defineProps({
  keepAlive: {
    type: Boolean,
    default: true,
  },
});

const route = useRoute();

// Routes that manage filters/pagination via query params opt out of
// query-keyed remounts, else every filter change rebuilds the page.
const routeKey = computed(() =>
  route.meta.reuseOnQueryChange ? route.path : route.fullPath
);
</script>

<template>
  <div
    class="flex h-full w-full flex-col overflow-auto bg-auth-canvas px-3 pb-8 pt-3 dark:bg-auth-canvas-dark sm:px-5 sm:pt-5 lg:px-8"
  >
    <div class="mx-auto flex w-full max-w-7xl items-start">
      <router-view v-slot="{ Component }">
        <keep-alive v-if="keepAlive">
          <component :is="Component" :key="routeKey" />
        </keep-alive>
        <component :is="Component" v-else :key="routeKey" />
      </router-view>
    </div>
  </div>
</template>
